import styled from 'styled-components'

const List = styled('ol')`
  margin: 0;
  display: flex;
`

export default List
